import React, { useState, useCallback } from 'react';
import ChooseScreen from './ChooseScreen';
import PrepareScreen from './PrepareScreen';
import ValidationView from './ValidationView';
import DownloadScreen from './DownloadScreen';
import StepIndicator from './StepIndicator';

const STEPS = ['choose', 'prepare', 'review', 'import'];

export default function App() {
  const [step, setStep] = useState('choose');
  const [profile, setProfile] = useState(null);
  const [validationResult, setValidationResult] = useState(null);
  const [transformedWorkbook, setTransformedWorkbook] = useState(null);

  const handleProfileSelect = useCallback((profileKey) => {
    setProfile(profileKey);
    setStep('prepare');
  }, []);

  const handleFileProcessed = useCallback(({ profile: p, validation, workbook }) => {
    setProfile(p);
    setValidationResult(validation);
    setTransformedWorkbook(workbook);
    setStep('review');
  }, []);

  const handleProceedToImport = useCallback(() => {
    setStep('import');
  }, []);

  const handleStartOver = useCallback(() => {
    setStep('choose');
    setProfile(null);
    setValidationResult(null);
    setTransformedWorkbook(null);
  }, []);

  const handleBackToChoose = useCallback(() => {
    setStep('choose');
    setProfile(null);
  }, []);

  const handleBackToPrepare = useCallback(() => {
    setStep('prepare');
    setValidationResult(null);
    setTransformedWorkbook(null);
  }, []);

  const handleBackToReview = useCallback(() => {
    setStep('review');
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-mv-800 text-white shadow-lg">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 shrink-0">
            <div className="w-8 h-8 bg-white/20 rounded flex items-center justify-center text-sm font-bold">
              MV
            </div>
            <div>
              <h1 className="text-lg font-semibold leading-tight">MV Import Tool</h1>
              <p className="text-xs text-blue-200 hidden sm:block">Multiview ERP Interface Converter</p>
            </div>
          </div>
          <StepIndicator step={step} steps={STEPS} />
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
        {step === 'choose' && <ChooseScreen onSelect={handleProfileSelect} />}

        {step === 'prepare' && profile && (
          <PrepareScreen
            profile={profile}
            onFileProcessed={handleFileProcessed}
            onBack={handleBackToChoose}
          />
        )}

        {step === 'review' && profile && validationResult && (
          <ValidationView
            profile={profile}
            validation={validationResult}
            onProceed={handleProceedToImport}
            onStartOver={handleStartOver}
            onBack={handleBackToPrepare}
          />
        )}

        {step === 'import' && profile && transformedWorkbook && validationResult && (
          <DownloadScreen
            profile={profile}
            workbook={transformedWorkbook}
            validation={validationResult}
            onStartOver={handleStartOver}
            onBack={handleBackToReview}
          />
        )}
      </main>
    </div>
  );
}
